import { computed } from "vue";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";
import type { JWTPayload } from "@shared/stores/keycloak.ts";

export const isSamlTokenPayload = (payload: JWTPayload | null): boolean => {
  if (!payload) return false;
  return (
    typeof payload.idp_alias === "string" &&
    payload.idp_alias.toLowerCase().includes("saml") &&
    !!payload.org
  );
};

export const useSamlUser = () => {
  const keycloakStore = useKeycloakStore();
  const isSamlUser = computed(() =>
    isSamlTokenPayload(keycloakStore.tokenPayload),
  );
  return { isSamlUser };
};

export const getNamePartsFromEmail = (
  email: string,
): { firstName: string; lastName: string } => {
  const [localPart, domain] = email.split("@");
  return {
    firstName: localPart || "",
    lastName: domain || "",
  };
};
